export default __webpack_public_path__ + "static/media/r.c9cb14ed.png";